
































import { ColorEnum, ExplainScoreCriteriaDetailStepLayoutEnum, OrientationEnum, ScoreCriteriaDetailTypeEnum } from '../../enums';

import { ExplainScoreCriteriaMessages } from '../../models';

import { ExplainUtils } from '../../utils';

import Badge from '../badge.component.vue';

export default {
  name: 'explain-score-criteria-detail-step',
  props: {
    criteriaDetailType: {
      type: String,
      required: true
    },
    orientation: { // OrientationEnum
      type: String,
      default: OrientationEnum.LEFT
    },
    layout: { // ExplainScoreCriteriaDetailStepLayoutEnum
      type: String,
      default: ExplainScoreCriteriaDetailStepLayoutEnum.EXPANDED
    },
    messages: {
      type: Object,
      required: true
    }
  },
  components: {
    Badge
  },
  data: function () {
    return {
      ExplainScoreCriteriaDetailStepLayoutEnum,
      ColorEnum
    };
  },
  methods: {
    getCriteriaDetailImageUrl: function (criteriaDetailType: (ScoreCriteriaDetailTypeEnum | string)): string {
      const fileNameFn = {
        [ScoreCriteriaDetailTypeEnum.CATALOG_DEFINITION]: () => 'catalog-definition.gif',
        [ScoreCriteriaDetailTypeEnum.BUSINESS_RULES]: () => 'business-rules.gif',
        [ScoreCriteriaDetailTypeEnum.QUERY_CONTEXT]: () => 'wisdom-of-the-crowd.gif',
        [ScoreCriteriaDetailTypeEnum.USER_CONTEXT]: () => 'user-context.gif',
        default: () => 'custom-score.gif'
      };
      const fileName = (fileNameFn[criteriaDetailType] || fileNameFn.default)();
      return require(`../../assets/media/image/explain/${ fileName }`);
    },
    getCriteriaDetailIcon(criteriaDetailType: (ScoreCriteriaDetailTypeEnum | string)): string {
      return (ExplainUtils.getResultScoreCriteriaDetailIcon(criteriaDetailType) || 'abacus');
    },
    getCriteriaDetailMessages(criteriaDetailType: (ScoreCriteriaDetailTypeEnum | string)): ExplainScoreCriteriaMessages {
      return ExplainUtils.getResultScoreCriteriaDetailMessages(criteriaDetailType, this.messages);
    }
  }
};
